var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.row.product.name)+" ")]),_vm._l((_vm._.sortBy(_vm.row.attributes, 'attribute.name')),function(attributeValue){return _c('AttributeValueBadge',{key:attributeValue.id,attrs:{"attribute-value":attributeValue}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }